import type * as React from 'react';
import { ConfirmDialog } from '@verclam/ui-kit';

type Props = {
	readonly visible: boolean;
	readonly onHide: () => void;
	readonly onAccept: () => void;
};

/** Accepting sends the empty value at once: the refused value is replaced by nothing. */
const LeaveFieldEmptyDialog: React.FC<Props> = ({ visible, onHide, onAccept }) => {
	return (
		<ConfirmDialog
			visible={visible}
			onHide={onHide}
			header="Laisser ce champ vide ?"
			message="Le champ partira vide dans le document."
			acceptLabel="Laisser vide"
			rejectLabel="Annuler"
			accept={onAccept}
		/>
	);
};

export default LeaveFieldEmptyDialog;
